import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/pixelify-sans';
import '@fontsource-variable/space-grotesk';
import '@fontsource/jetbrains-mono/latin-400.css';
import './styles/global.css';
import { App } from './App';
import { applyBrandFavicon } from './components/Logo';
import { loadPrefs } from './prefs';
import { applyTheme } from './theme';

applyTheme(loadPrefs().theme);
void applyBrandFavicon();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
